import React, { useState } from "react";
import "../Styles/NodeJs.css";
import { Helmet } from "react-helmet";

const NodeJs = () => {
  const [selectedService, setSelectedService] = useState(1);

  const handleClick = (serviceId) => {
    setSelectedService(serviceId);
  };

  const getServiceContent = (serviceId) => {
    switch (serviceId) {
      case 1:
        return (
          <div style={{ marginTop: "30px" }}>
            <h3>Custom Web Applications</h3>
            <p>
              Our team specializes in designing and developing custom web
              applications tailored to your business needs. Whether it’s an
              eCommerce platform to enhance online sales, a content management
              system to streamline your digital content, or advanced data
              analytics tools to derive actionable insights, we utilize the
              speed, efficiency, and reliability of Node.js to deliver solutions
              that exceed expectations.
            </p>
          </div>
        );
      case 2:
        return (
          <div style={{ marginTop: "30px" }}>
            <h3>Dynamic Dashboards</h3>
            <p>
              Leverage the power of interactive and visually engaging dashboards
              designed to provide real-time data insights. With Node.js at its
              core, our dashboards enable businesses to monitor operations,
              track performance metrics, and make data-driven decisions with
              ease, ensuring enhanced productivity and control.
            </p>
          </div>
        );
      case 3:
        return (
          <div style={{ marginTop: "30px" }}>
            <h3>Social Media Applications</h3>
            <p>
              We create feature-rich, scalable, and user-centric social media
              applications that foster engagement and seamless interactions.
              From real-time notifications and activity feeds to advanced
              security and scalability features, Node.js empowers us to build
              social media platforms that deliver exceptional user experiences.
            </p>
          </div>
        );
      case 4:
        return (
          <div style={{ marginTop: "30px" }}>
            <h3>Real-Time Chat Applications</h3>
            <p>
              Transform user communication with robust, real-time chat
              applications. Our Node.js-based solutions ensure smooth
              connectivity, instant messaging, and high reliability, making them
              ideal for businesses aiming to offer real-time communication
              services, whether for customer support, team collaboration, or
              social networking.
            </p>
          </div>
        );
      case 5:
        return (
          <div style={{ marginTop: "30px" }}>
            <h3>API Development</h3>
            <p>
              Simplify the integration of your systems and enable seamless data
              exchange between applications with our efficient API development
              services. Node.js allows us to build secure, high-performance APIs
              that can handle complex workflows and ensure smooth communication
              across diverse platforms.
            </p>
          </div>
        );
      default:
        return <p>Select a service to see the explanation.</p>;
    }
  };
  return (
    <>
      <Helmet>
        <title>Node.js Development Services | Piquota</title>
        <meta
          name="description"
          content="Explore our Node.js development services for scalable, high-performance web applications. Build real-time applications, APIs, and more with Piquota's expertise."
        />
        <meta
          name="keywords"
          content="Node.js development, Node.js, real-time applications, API development, web development, microservices architecture, Piquota"
        />
        <meta
          property="og:title"
          content="Node.js Development Services | Piquota"
        />
        <meta
          property="og:description"
          content="Explore our Node.js development services for scalable, high-performance web applications. Build real-time applications, APIs, and more with Piquota's expertise."
        />
        <meta
          property="og:url"
          content="https://www.piquota.ai/nodejs-development"
        />
        <meta
          name="twitter:title"
          content="Node.js Development Services | Piquota"
        />
        <meta
          name="twitter:description"
          content="Explore our Node.js development services for scalable, high-performance web applications. Build real-time applications, APIs, and more with Piquota's expertise."
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/* Banner Section */}
      <div
        className="container-fluid"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
            url('Assets/Images/pexels-photo-12198537.webp')`,
          backgroundSize: "cover",
          backgroundPosition: "right",
          height: "100vh",
        }}
      >
        <div
          className="row align-items-center h-100 text-white p-3 p-sm-5"
          style={{ maxWidth: "100%", margin: "0 auto" }}
        >
          <div className="col-12">
            <h1
              className="fs-1"
              style={{
                fontWeight: 600,
                letterSpacing: "2px",
                textAlign: "left",
                color: "white",
                marginLeft: "80px",
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              Node.Js Development
            </h1>
            <h2
              className="fs-1"
              style={{
                fontWeight: 600,
                marginTop: "10px",
                textAlign: "left",
                color: "white",
                marginLeft: "80px",
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              Services
              <span class="rectangle"></span>
            </h2>
          </div>
        </div>
      </div>

      {/* Section 1 */}
      <div className="container my-5" style={{ marginRight: "90px" }}>
        <div className="row mx-0 align-items-center">
          {/* First Column */}
          <div className="col-12 col-md-5 text-center text-md-start">
            <h2
              style={{
                fontWeight: 600,
                letterSpacing: "1px",
                marginTop: "0px",
              }}
            >
              Why Choose
              <br /> Node.js for Your
              <br /> Business?
              <span className="rectangle1"></span>
            </h2>
          </div>

          {/* Right Side Columns */}
          <div className="col-12 col-md-7">
            <div className="row mx-0">
              {/* Column 1 */}
              <div className="col-12 col-sm-6 col-md-4 text-left mb-4 d-flex">
                <div>
                  <img
                    src="Assets/Images/transfer_11235262.png"
                    alt="Lightweight Sophistication"
                    className="img-fluid"
                    style={{
                      maxWidth: "60px",
                      height: "auto",
                      marginBottom: "10px",
                    }}
                  />
                  <h4
                    style={{
                      fontWeight: 600,
                      fontSize: "20px",
                    }}
                  >
                    Streamlined Efficiency
                  </h4>
                  <p
                    style={{
                      fontWeight: "500",
                      fontSize: "16px",
                      margin: "0",
                    }}
                  >
                    Node.js is lightweight and optimized for high-demand
                    applications.
                  </p>
                </div>
              </div>

              {/* Column 2 */}
              <div className="col-12 col-sm-6 col-md-4 text-left mb-4 d-flex">
                <div>
                  <img
                    src="Assets/Images/scalability_15203457.png"
                    alt="Improves Scalability"
                    className="img-fluid"
                    style={{
                      maxWidth: "60px",
                      height: "auto",
                      marginBottom: "10px",
                    }}
                  />
                  <h4
                    style={{
                      fontWeight: 600,
                      fontSize: "20px",
                    }}
                  >
                    Enhanced Scalability
                  </h4>
                  <p
                    style={{
                      fontWeight: "500",
                      fontSize: "16px",
                      margin: "0",
                    }}
                  >
                    Handle growing user traffic effortlessly with Node.js's
                    robust architecture.
                  </p>
                </div>
              </div>

              {/* Column 3 */}
              <div className="col-12 col-sm-6 col-md-4 text-left mb-4 d-flex">
                <div>
                  <img
                    src="Assets/Images/agile_9608966.png"
                    alt="Agility Driven"
                    className="img-fluid"
                    style={{
                      maxWidth: "60px",
                      height: "auto",
                      marginBottom: "10px",
                    }}
                  />
                  <h4
                    style={{
                      fontWeight: 600,
                      fontSize: "20px",
                    }}
                  >
                    Agility at Its Core
                  </h4>
                  <p
                    style={{
                      fontWeight: "500",
                      fontSize: "16px",
                      margin: "0",
                    }}
                  >
                    Adapt to dynamic needs with Node.js's flexibility for
                    resource-heavy applications.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 */}
      <div className="container my-5 nodejs-services-section">
        <div className="row mx-0">
          <div className="col-12 text-center">
            <h2
              style={{
                fontWeight: 600,
                marginTop: "60px",
              }}
            >
              Our Node.js Development Services
              <span class="rectangle1"></span>
            </h2>
          </div>
        </div>

        <div className="row mx-0 mt-5">
          {/* Left Column */}
          <div
            className="col-12 col-md-5 nodejs-services-section-left"
            style={{
              backgroundColor: "#333333",
              borderRight: "1px solid #ccc",
              padding: "40px",
              height: "500px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRight: "1px solid #333333",
            }}
          >
            <div className="list-group w-100">
              {/* Web Development */}
              <button
                className={`list-group-item list-group-item-action d-flex align-items-center ${
                  selectedService === 1 ? "active" : ""
                }`}
                onClick={() => handleClick(1)}
                style={{
                  cursor: "pointer",
                  padding: "20px",
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "left",
                  color: selectedService === 1 ? "white" : "#B0B0B0",
                  borderBottom: "1px solid #ccc",
                  position: "relative",
                  fontSize: "18px",
                }}
              >
                <i
                  className="fas fa-laptop"
                  style={{
                    fontSize: "36px",
                    marginRight: "15px",
                    color: selectedService === 1 ? "white" : "#B0B0B0",
                  }}
                ></i>
                Web Development
                <span
                  className={`arrow ${selectedService === 1 ? "rotate" : ""}`}
                  style={{
                    position: "absolute",
                    right: "20px",
                    transition: "transform 0.3s ease, margin-left 0.3s ease",
                  }}
                >
                  &rarr;
                </span>
              </button>

              {/* Dashboard Development */}
              <button
                className={`list-group-item list-group-item-action d-flex align-items-center ${
                  selectedService === 2 ? "active" : ""
                }`}
                onClick={() => handleClick(2)}
                style={{
                  cursor: "pointer",
                  padding: "20px",
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "left",
                  color: selectedService === 2 ? "white" : "#B0B0B0",
                  borderBottom: "1px solid #ccc",
                  position: "relative",
                  fontSize: "18px",
                }}
              >
                <i
                  className="fas fa-tachometer-alt"
                  style={{
                    fontSize: "36px",
                    marginRight: "15px",
                    color: selectedService === 2 ? "white" : "#B0B0B0",
                  }}
                ></i>
                Dashboard Development
                <span
                  className={`arrow ${selectedService === 2 ? "rotate" : ""}`}
                  style={{
                    position: "absolute",
                    right: "20px",
                    transition: "transform 0.3s ease, margin-left 0.3s ease",
                  }}
                >
                  &rarr;
                </span>
              </button>

              {/* Social Media Application Development */}
              <button
                className={`list-group-item list-group-item-action d-flex align-items-center ${
                  selectedService === 3 ? "active" : ""
                }`}
                onClick={() => handleClick(3)}
                style={{
                  cursor: "pointer",
                  padding: "20px",
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "left",
                  color: selectedService === 3 ? "white" : "#B0B0B0",
                  borderBottom: "1px solid #ccc",
                  position: "relative",
                  fontSize: "18px",
                }}
              >
                <i
                  className="fas fa-users"
                  style={{
                    fontSize: "36px",
                    marginRight: "15px",
                    color: selectedService === 3 ? "white" : "#B0B0B0",
                  }}
                ></i>
                Social Media Application Development
                <span
                  className={`arrow ${selectedService === 3 ? "rotate" : ""}`}
                  style={{
                    position: "absolute",
                    right: "20px",
                    transition: "transform 0.3s ease, margin-left 0.3s ease",
                  }}
                >
                  &rarr;
                </span>
              </button>

              {/* Real-Time Chat Application Development */}
              <button
                className={`list-group-item list-group-item-action d-flex align-items-center ${
                  selectedService === 4 ? "active" : ""
                }`}
                onClick={() => handleClick(4)}
                style={{
                  cursor: "pointer",
                  padding: "20px",
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "left",
                  color: selectedService === 4 ? "white" : "#B0B0B0",
                  borderBottom: "1px solid #ccc",
                  position: "relative",
                  fontSize: "18px",
                }}
              >
                <i
                  className="fas fa-comment-alt"
                  style={{
                    fontSize: "36px",
                    marginRight: "15px",
                    color: selectedService === 4 ? "white" : "#B0B0B0",
                  }}
                ></i>
                Real-Time Chat Application Development
                <span
                  className={`arrow ${selectedService === 4 ? "rotate" : ""}`}
                  style={{
                    position: "absolute",
                    right: "20px",
                    transition: "transform 0.3s ease, margin-left 0.3s ease",
                  }}
                >
                  &rarr;
                </span>
              </button>

              {/* API Development */}
              <button
                className={`list-group-item list-group-item-action d-flex align-items-center ${
                  selectedService === 5 ? "active" : ""
                }`}
                onClick={() => handleClick(5)}
                style={{
                  cursor: "pointer",
                  padding: "20px",
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "left",
                  color: selectedService === 5 ? "white" : "#B0B0B0",
                  position: "relative",
                  fontSize: "18px",
                }}
              >
                <i
                  className="fas fa-code"
                  style={{
                    fontSize: "36px",
                    marginRight: "15px",
                    color: selectedService === 5 ? "white" : "#B0B0B0",
                  }}
                ></i>
                API Development
                <span
                  className={`arrow ${selectedService === 5 ? "rotate" : ""}`}
                  style={{
                    position: "absolute",
                    right: "20px",
                    transition: "transform 0.3s ease, margin-left 0.3s ease",
                  }}
                >
                  &rarr;
                </span>
              </button>
            </div>
          </div>

          {/* Right Column - Dynamic Explanation */}
          <div
            className="col-12 col-md-7 nodejs-services-section-left"
            style={{
              backgroundColor: "#ffffff",
              padding: "40px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              borderTop: "1px solid #E7E7E7",
              borderBottom: "1px solid #E7E7E7",
              borderRight: "1px solid #E7E7E7",
            }}
          >
            {/* Displaying Service Content */}
            {selectedService ? (
              getServiceContent(selectedService)
            ) : (
              <p>Select a service to see details</p>
            )}
          </div>
        </div>
      </div>

      {/* Section 3 */}
      <div className="container-fluid px-0 my-5">
        <div className="row mx-0 section3">
          {/* Left Column */}
          <div className="col-12 col-md-7 d-flex align-items-center justify-content-center mt-3">
            <h3 className="heading-text">Build powerful Node.js solutions.</h3>
          </div>

          {/* Right Column */}
          <div className="col-12 col-md-5 d-flex align-items-center justify-content-md-start justify-content-center">
            <div>
              <a href="/contact" style={{ textDecoration: "none" }}>
                <i
                  className="fas fa-arrow-right"
                  style={{ fontSize: "38px" }}
                ></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Section 4 */}
      <div className="container-fluid my-5">
        <div className="row mx-0 align-items-center justify-content-center">
          {/* Left Column  */}
          <div className="col-12 col-md-6 d-flex justify-content-center">
            <img
              src="Assets/Images/API Development.jpg"
              alt="Node.js"
              className="img-fluid"
              style={{
                maxWidth: "80%",
                width: "100%",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Right Column */}
          <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">
            <div className="content-wrapper">
              <h3
                style={{
                  fontWeight: "600",
                  fontSize: "28px",
                  marginBottom: "30px",
                  color: "#333",
                  textAlign: "left",
                }}
              >
                Node.js Technology Stack at Piquota
              </h3>
              <div className="custom-list">
                <div className="line-items" style={{ fontWeight: "400" }}>
                  API Development for seamless communication
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Real-time Applications with event-driven architecture
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Microservices Architecture for modular development
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Database Integration for efficient data handling
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Application Maintenance
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Support to keep your business running smoothly
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Application Maintenance & Support
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 5 */}
      <div className="container-fluid px-5 py-5">
        <div className="text-center mb-4">
          <h2
            style={{
              fontWeight: "600",
              fontSize: "2rem",
              color: "#333",
              margin: "20px auto 30px",
            }}
          >
            Get the Agile Competitive Edge with Node.js
            <span class="rectangle1"></span>
          </h2>
          <p
            style={{
              fontSize: "1.2rem",
              color: "#555",
              lineHeight: "1.6",
              margin: "20px auto 80px",
              fontWeight: "400",
            }}
          >
            Harness the power of Node.js for scalable, high-performance web
            applications. Respond to <br />
            dynamic business environments with a robust backend, faster
            execution speeds, and seamless
            <br />
            integrations, all driven by the versatility and adaptability of
            Node.js development.
          </p>
        </div>

        <div className="row text-center">
          {/* Row 1 */}
          <div className="col-12 col-md-3 mb-4">
            <img
              src="Assets/Images/10699360.png"
              alt="Non-blocking Architecture"
              className="img-fluid mb-3"
              style={{ width: "120px" }}
            />
            <h5 style={{ fontWeight: "500", color: "#333" }}>
              Non-blocking Architecture
            </h5>
          </div>
          <div className="col-12 col-md-3 mb-4">
            <img
              src="Assets/Images/12226874.png"
              alt="Real-time Applications"
              className="img-fluid mb-3"
              style={{ width: "120px" }}
            />
            <h5 style={{ fontWeight: "500", color: "#333" }}>
              Real-time Applications
            </h5>
          </div>
          <div className="col-12 col-md-3 mb-4">
            <img
              src="Assets/Images/17512752.png"
              alt="Event-driven Design"
              className="img-fluid mb-3"
              style={{ width: "120px" }}
            />
            <h5 style={{ fontWeight: "500", color: "#333" }}>
              Event-driven Design
            </h5>
          </div>
          <div className="col-12 col-md-3 mb-4">
            <img
              src="Assets/Images/17335091.png"
              alt="API Development"
              className="img-fluid mb-3"
              style={{ width: "120px" }}
            />
            <h5 style={{ fontWeight: "500", color: "#333" }}>
              API Development
            </h5>
          </div>
        </div>

        <div className="row text-center">
          {/* Row 2 */}
          <div className="col-12 col-md-2 mb-4">
            <img
              src="Assets/Images/18045089.png"
              alt="Microservices Architecture"
              className="img-fluid mb-3"
              style={{ width: "120px" }}
            />
            <h5 style={{ fontWeight: "500", color: "#333" }}>
              Microservices Architecture
            </h5>
          </div>
          <div className="col-12 col-md-2 mb-4 ">
            <img
              src="Assets/Images/5700487.png"
              alt="High Scalability"
              className="img-fluid mb-3"
              style={{ width: "120px" }}
            />
            <h5 style={{ fontWeight: "500", color: "#333" }}>
              High Scalability
            </h5>
          </div>
          <div className="col-12 col-md-2 mb-4">
            <img
              src="Assets/Images/4731444.png"
              alt="Third-party Integrations"
              className="img-fluid mb-3"
              style={{ width: "120px" }}
            />
            <h5 style={{ fontWeight: "500", color: "#333" }}>
              Third-party Integrations
            </h5>
          </div>
          <div className="col-12 col-md-2 mb-4">
            <img
              src="Assets/Images/6854809.png"
              alt="Automated Testing"
              className="img-fluid mb-3"
              style={{ width: "120px" }}
            />
            <h5 style={{ fontWeight: "500", color: "#333" }}>
              Automated Testing
            </h5>
          </div>
        </div>
      </div>

      {/* Section 6 */}
      <div
        className="container-fluid my-0"
        style={{
          backgroundColor: "#E9E8E9",
          paddingBottom: "40px",
          paddingTop: "50px",
        }}
      >
        <div className="row mx-0">
          <div className="col-12 text-center">
            <h2
              style={{
                fontWeight: "600",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "36px",
                color: "#333",
                marginBottom: "50px",
              }}
            >
              Our Work
              <span class="rectangle1"></span>
            </h2>
          </div>
        </div>

        <div className="row mx-0 align-items-center">
          {/* Left Column  */}
          <div
            className="col-12 col-md-6"
            style={{
              paddingLeft: "100px",
              marginTop: "40px",
              marginBottom: "40px",
            }}
          >
            <div style={{ marginRight: "30px" }}>
              <h4
                style={{
                  fontWeight: "600",
                  fontSize: "22px",
                  color: "#555",
                  marginBottom: "15px",
                }}
              >
                Featured Services
              </h4>

              <p
                style={{
                  fontWeight: "400",
                  fontSize: "18px",
                  color: "#333",
                  marginBottom: "20px",
                }}
              >
                We have delivered mission-critical web applications using
                JavaScript-based technologies. Here are some highlights of our
                work:
              </p>

              {/* Points */}
              <div className="custom-list">
                <div className="line-items" style={{ fontWeight: "400" }}>
                  API Development
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Real-Time Applications
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Microservices Architecture
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  E-Commerce Solutions
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Database Integration
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Application Maintenance & Support
                </div>
                <div className="line-items" style={{ fontWeight: "400" }}>
                  Live Chat Web App
                </div>
              </div>
            </div>
          </div>

          {/* Right Column  */}
          <div
            className="col-12 col-md-6 d-flex justify-content-center"
            style={{ marginBottom: "40px" }}
          >
            <img
              src="Assets/Images/pexels-fotios-photos-16129724 (1).jpg"
              alt="Node"
              className="img-fluid"
              style={{
                borderRadius: "8px",
                maxWidth: "80%",
                height: "auto",
                objectFit: "contain",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            />
          </div>
        </div>
      </div>

      {/* Section 7 */}
      <div className="container my-5 ">
        <h2
          className="section-heading text-center"
          style={{ fontWeight: "600" }}
        >
          Industry Expertise
          <span className="rectangle1"></span>
        </h2>
        <p
          className="section-heading text-center m-4 w-75 mx-auto"
          style={{ fontSize: "22px", fontWeight: "400" }}
        >
          We have delivered enterprise-grade software solutions across
          industries for clients around the globe. With relevant experience and
          efficient processes, our team designs and develops web applications
          suited to startups, SMBs, and large enterprises. Here are some
          industries where we excel
        </p>
        {/* First Row */}
        <div className="row mx-0 mt-5">
          <div className="col-12 col-md-3 mb-4">
            <div className="service-box text-center">
              <img
                src="Assets/Images/pexels-anastasiya-gepp-654466-1462630.jpg"
                alt="Education"
                className="img-fluid mb-3"
              />
              <h4
                className="service-heading"
                style={{ fontWeight: "600", fontSize: "20px" }}
              >
                Education
              </h4>
            </div>
          </div>

          <div className="col-12 col-md-3 mb-4">
            <div className="service-box text-center">
              <img
                src="Assets/Images/pexels-shvetsa-3962285.jpg"
                alt="Grocery"
                className="img-fluid mb-3"
              />
              <h4
                className="service-heading"
                style={{ fontWeight: "600", fontSize: "20px" }}
              >
                Grocery
              </h4>
            </div>
          </div>

          <div className="col-12 col-md-3 mb-4">
            <div className="service-box text-center">
              <img
                src="Assets/Images/pexels-asphotograpy-230544 (1).jpg"
                alt="eCommerce"
                className="img-fluid mb-3"
              />
              <h4
                className="service-heading"
                style={{ fontWeight: "600", fontSize: "20px" }}
              >
                eCommerce
              </h4>
            </div>
          </div>

          <div className="col-12 col-md-3 mb-4">
            <div className="service-box text-center">
              <img
                src="Assets/Images/pexels-james-collington-2147687246-29979994.jpg"
                alt="Food & Beverages"
                className="img-fluid mb-3"
              />
              <h4
                className="service-heading"
                style={{ fontWeight: "600", fontSize: "20px" }}
              >
                Food & Beverages
              </h4>
            </div>
          </div>
        </div>

        {/* Second Row */}
        <div className="row mx-0 mt-3">
          <div className="col-12 col-md-3 mb-4">
            <div className="service-box text-center">
              <img
                src="Assets/Images/pexels-tirachard-kumtanom-112571-347134.jpg"
                alt="Healthcare & Fitness"
                className="img-fluid mb-3"
              />
              <h4
                className="service-heading"
                style={{ fontWeight: "600", fontSize: "20px" }}
              >
                Healthcare & Fitness
              </h4>
            </div>
          </div>

          <div className="col-12 col-md-3 mb-4">
            <div className="service-box text-center">
              <img
                src="Assets/Images/pexels-august-de-richelieu-4427813.jpg"
                alt="Communication"
                className="img-fluid mb-3"
              />
              <h4
                className="service-heading"
                style={{ fontWeight: "600", fontSize: "20px" }}
              >
                Communication
              </h4>
            </div>
          </div>

          <div className="col-12 col-md-3 mb-4">
            <div className="service-box text-center">
              <img
                src="Assets/Images/pexels-elevate-1267324.jpg"
                alt="Logistics & Transportation"
                className="img-fluid mb-3"
              />
              <h4
                className="service-heading"
                style={{ fontWeight: "600", fontSize: "20px" }}
              >
                Logistics & Transportation
              </h4>
            </div>
          </div>

          <div className="col-12 col-md-3 mb-4">
            <div className="service-box text-center">
              <img
                src="Assets/Images/pexels-marta-wave-6437607.jpg"
                alt="Online Video & Entertainment"
                className="img-fluid mb-3"
              />
              <h4
                className="service-heading"
                style={{ fontWeight: "600", fontSize: "20px" }}
              >
                Online Video & Entertainment
              </h4>
            </div>
          </div>
        </div>
      </div>

      {/* Section 8 */}
      <div
        className="container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "100px",
        }}
      >
        <div
          className="row mx-0 align-items-center"
          style={{ width: "100%", justifyContent: "center" }}
        >
          {/* Left Column  */}
          <div
            className="col-12 col-md-8 "
            style={{
              paddingRight: "50px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <h3
              style={{
                fontWeight: "600",
                fontSize: "30px",
                marginBottom: "30px",
                color: "#2e2e2e",
              }}
            >
              Why Choose Us For Node <br /> Development Services
              <span className="rectangle1"></span>
            </h3>
            <p
              style={{
                fontWeight: "400",
                fontSize: "20px",
                color: "#333",
                lineHeight: "1.6",
                marginBottom: "30px",
              }}
            >
              As a full-service web app development agency, we provide
              comprehensive support through every stage, including analysis,
              design, development, and growth. Our experienced team adopts a
              process-driven approach to tackle scalability challenges and help
              implement new business models seamlessly.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "30px",
                marginBottom: "30px",
                textAlign: "left",
              }}
            >
              <div style={{ margin: "0 10px", width: "10%" }}>
                <img
                  src="Assets/Images/Team Colloboratioj.png"
                  alt="Image 1"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
                <p
                  style={{ fontSize: "14px", marginTop: "10px", color: "#333" }}
                >
                  Team Collaboration
                </p>
              </div>
              <div style={{ margin: "0 10px", width: "10%" }}>
                <img
                  src="Assets/Images/images (1).png"
                  alt="Image 2"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
                <p
                  style={{ fontSize: "14px", marginTop: "10px", color: "#333" }}
                >
                  Innovative Ideas
                </p>
              </div>
              <div style={{ margin: "0 10px", width: "10%" }}>
                <img
                  src="Assets/Images/3094843.png"
                  alt="Image 3"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
                <p
                  style={{ fontSize: "14px", marginTop: "10px", color: "#333" }}
                >
                  Smart Solutions
                </p>
              </div>
              <div style={{ margin: "0 10px", width: "10%" }}>
                <img
                  src="Assets/Images/analytics.png"
                  alt="Image 4"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
                <p
                  style={{ fontSize: "14px", marginTop: "10px", color: "#333" }}
                >
                  Data Analytics
                </p>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div
            className="col-12 col-md-3"
            style={{
              height: "300px",
            }}
          >
            <div
              style={{
                backgroundColor: "#742e92",
                padding: "10px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ marginBottom: "10px", textAlign: "left" }}>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "300",
                    marginBottom: "8px",
                    color: "white",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>- </span>5+ Years
                  Experience
                </div>
              </div>
              <div style={{ marginBottom: "10px", textAlign: "left" }}>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "300",
                    marginBottom: "8px",
                    color: "white",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>- </span>50+ Team Members
                </div>
              </div>
              <div style={{ marginBottom: "10px", textAlign: "left" }}>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "300",
                    marginBottom: "8px",
                    color: "white",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>- </span>Agile
                  Development
                </div>
              </div>
              <div style={{ textAlign: "left" }}>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "300",
                    marginBottom: "8px",
                    color: "white",
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>- </span>Transparent
                  Process
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NodeJs;
